export const editSellerProfileSettings = `
  mutation EditSellerSettings ($settings: [PatchOptions]!, $slugName: String!) {
    editSellerProfileSettings (editSlugDetails: $settings, slug: $slugName) {
      isProfileStatusActive
      userInfo {
        alternateFullName
        businessCategory
        displayAddress
        displayEmail
        displayMobilePhone
        website
        instagramUsername
        facebookUrl
        twitterHandle
        profilePhotoUrl
      }
      privacySettings {
        emailSearchEnabled
        phoneSearchEnabled
        location
      }
      personalizationSettings {
        description
        coverPhotoUrl
      }
    }
  }
`
